import { SET_NAVIGATION } from '../constants';

export const doSetNavigation =
  ({ shouldConfirmNavigation = false } = {}) =>
  async ({ dispatch }) => {
    dispatch({ payload: { shouldConfirmNavigation }, type: SET_NAVIGATION });
  };
